import type { ReactNode } from 'react'

export interface KeyValueItem {
  label: string
  value: ReactNode
}

/** A definition list for a record's facts (a run's header, a preset's summary). */
export function KeyValueList({ items, columns = 2 }: { items: KeyValueItem[]; columns?: 1 | 2 | 3 }) {
  const cols =
    columns === 1
      ? 'grid-cols-1'
      : columns === 2
        ? 'grid-cols-1 sm:grid-cols-2'
        : 'grid-cols-1 sm:grid-cols-3'
  return (
    <dl className={`grid gap-x-4 gap-y-2 ${cols}`}>
      {items.map((it) => (
        <div key={it.label} className="min-w-0">
          <dt className="text-2xs font-medium uppercase tracking-wide text-muted">{it.label}</dt>
          <dd className="mt-0.5 break-words text-xs text-default">
            {it.value ?? <span className="text-muted">—</span>}
          </dd>
        </div>
      ))}
    </dl>
  )
}
